<div id="forgot-password" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="forgot-password-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="assets/images/logos/logogro.png">
        </div>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            <span class="name_title">e</span>.Justicia
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            Iniciamos una nueva era en la impartición de Justicia Administrativa
        </div>

    </div>

    <div id="forgot-password-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="forgot-password-form">

            <div class="logo" fxHide.gt-xs>
                <img src="assets/images/logos/logogro.png">
            </div>

            <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}" fxHide.gt-xs>
                <span class="name_title">e</span>.Justicia
                <div class="h2 email">Administrativa Durango</div>
            </div>

            <div class="title">
                <div class="h2">RECUPERAR TU CONTRASEÑA</div>
            </div>

            <form name="forgoPasswordForm" [formGroup]="forgotPasswordForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>Correo</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="forgotPasswordForm.get('email').hasError('required')">
                        Correo es requerido
                    </mat-error>
                    <mat-error *ngIf="forgotPasswordForm.get('email').hasError('email')">
                        Por favor ingrese un correo valido
                    </mat-error>
                </mat-form-field>

                <mat-error fxLayout="column" fxLayoutAlign="center center">
                    {{ msjError }}
                </mat-error>

                <mat-error *ngIf="errorMsjOk != ''" class="error-center mt-24">{{ errorMsjOk }}</mat-error>


                <button mat-raised-button class="submit-button" color="accent" (click)="recoverCredential()" aria-label="SEND RESET LINK" [disabled]="forgotPasswordForm.invalid || loading">
                    ENVIAR CORREO
                    <div fxLayout="column" fxLayoutAlign="center center " *ngIf="loading">
                        <mat-progress-spinner
                            diameter="25"
                            mode="indeterminate">
                        </mat-progress-spinner>
                    </div>
                </button>
                <a mat-stroked-button color="accent" class="submit-button" [disabled]="loading" [routerLink]="'/'">
                    CANCELAR
                </a>

            </form>

            <div class="login" fxLayout="row" fxLayoutAlign="center center">
                <a class="link" [routerLink]="'/pages/auth/login'">Regresar al incio de sesión</a>
            </div>

        </div>
    </div>
</div>